/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Off_DoneInputs */

const en_push_off_done = /** @type {(inputs: Push_Off_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications turned off for this device`)
};

/**
* | output |
* | --- |
* | "Notifications turned off for this device" |
*
* @param {Push_Off_DoneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_off_done = /** @type {((inputs?: Push_Off_DoneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Off_DoneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_off_done(inputs)
});